/* globals window */

import Cookies from 'js-cookie';
import { put } from 'redux-saga/effects';

import logError from 'utils/rollbar';

import { ADD_API_ERROR, REMOVE_API_ERROR } from './constants';

export function* addAPIError(error) {
  const { response } = error;
  if (response && response.status === 401) {
    Cookies.remove('customerToken');
    window.location.href = `/profile/login`;
  }
  yield put({
    type: ADD_API_ERROR,
    payload: error
  });
  if (response) {
    if (response.status >= 500) logError(error);
  } else {
    logError(error);
  }
}

export function* removeAPIError() {
  yield put({
    type: REMOVE_API_ERROR
  });
}
